import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Modal from 'library/components/modal';
import SubscriptionInviteModalContent from 'library/components/employee-select';

class EmployeeSelectModal extends React.Component {

  static propTypes = {
    component: PropTypes.node,
    children: PropTypes.node,
    surveyed: PropTypes.bool,
    exclude: PropTypes.array
  }

  state = {
    active: false
  }

  toggleModal = () => {
    this.setState({
      active: !this.state.active
    });
  }

  render() {
    const {
      component:Component='button',
      children,
      surveyed,
      exclude,
      ...props
    } = this.props;

    return (
      <Fragment>
        <Component onClick={this.toggleModal} {...props}>{children}</Component>
        <Modal onClose={this.toggleModal} active={this.state.active}>
          <SubscriptionInviteModalContent
            surveyed={surveyed} {...props}
            onClose={this.toggleModal}
            exclude={exclude}
          />
        </Modal>
      </Fragment>
    );
  }
}

export default EmployeeSelectModal;
